export default function format(value) {
  if (!value || value.length !== 12) {
    return value;
  }

  return value.replace(/([\d]{8})([\d]{4})/, '$1-$2');
}
